export const COLLAPSE_MENU = 'COLLAPSE_MENU';
export const COLLAPSE_TOGGLE = 'COLLAPSE_TOGGLE';
export const FULL_SCREEN = 'FULL_SCREEN';
export const FULL_SCREEN_EXIT = 'FULL_SCREEN_EXIT';
export const CHANGE_LAYOUT = 'CHANGE_LAYOUT';
export const NAV_CONTENT_LEAVE = 'NAV_CONTENT_LEAVE';
export const NAV_COLLAPSE_LEAVE = 'NAV_COLLAPSE_LEAVE';

export const RESET = 'RESET';

export const HANDLE_USERS = "HANDLE_USERS";
export const HANDLE_MANAGEMENT_USERS = "HANDLE_MANAGEMENT_USERS";
export const HANDLE_CUSTOMER = "HANDLE_CUSTOMER";
export const HANDLE_MACHINE_JOBCARD = "HANDLE_MACHINE_JOBCARD";
export const HANDLE_JOB_CARD = "HANDLE_JOB_CARD";
export const SET_DEFAULT_JOB_CARD = "SET_DEFAULT_JOB_CARD";
export const SET_GLOBAL_DROPDOWN = "SET_GLOBAL_DROPDOWN";

export const HANDLE_REPORT = "HANDLE_REPORT";

export const HANDLE_PRODUCT = "HANDLE_PRODUCT";
export const HANDLE_USER_PRODUCT = "HANDLE_USER_PRODUCT";

export const HANDLE_JOB_CARD_NEW = "HANDLE_JOB_CARD_NEW";
export const HANDLE_JOB_CARD_SER = "HANDLE_JOB_CARD_SER";
export const HANDLE_JOB_CARD_AMC = "HANDLE_JOB_CARD_AMC";

export const HANDLE_MACHINE = "HANDLE_MACHINE";
export const HANDLE_CONTACT_PERSON = "HANDLE_CONTACT_PERSON";
export const HANDLE_PROBLEM = "HANDLE_PROBLEM";


export const HANDLE_SERVICE_INFORMATION = "HANDLE_SERVICE_INFORMATION";
export const SET_DEFAULT_SERVICE_INFORMATION = "SET_DEFAULT_SERVICE_INFORMATION";

export const HANDLE_MACHINE_RANGE = "HANDLE_MACHINE_RANGE";

export const HANDLE_SPARE = "HANDLE_SPARE";
export const HANDLE_QUOTATION = "HANDLE_QUOTATION";
export const HANDLE_INDENT = "HANDLE_INDENT";
export const HANDLE_DELIVERY_CHELLAN = "HANDLE_DELIVERY_CHELLAN";
export const HANDLE_INVOICE = "HANDLE_INVOICE";

export const HANDLE_AMC = "HANDLE_AMC";

export const HANDLE_REGION = "HANDLE_REGION";
export const HANDLE_SUPPLIER = "HANDLE_SUPPLIER";

export const HANDLE_ORDER_REQUEST = "HANDLE_ORDER_REQUEST";
export const HANDLE_INVENTORY_GROUP = "HANDLE_INVENTORY_GROUP";
export const HANDLE_PROFILE = "HANDLE_PROFILE";
export const HANDLE_STOCK = "HANDLE_STOCK";
export const HANDLE_STOCK_OUTWARD = "HANDLE_STOCK_OUTWARD";
export const HANDLE_ORDER_REQUEST_LOG = "HANDLE_ORDER_REQUEST_LOG";

export const HANDLE_DELIVERVED_ITEMS = "HANDLE_DELIVERVED_ITEMS";
export const HANDLE_ITEMS_DELIVERVED_DETAIL = "HANDLE_ITEMS_DELIVERVED_DETAIL";
export const HANDLE_PENDING_ITEMS = "HANDLE_PENDING_ITEMS";
export const HANDLE_ITEMS_REPORT = "HANDLE_ITEMS_REPORT";